export const DEFAULT_PORTAL_PRIMARY_COLOR = "#F43F5E";
export const DEFAULT_PORTAL_TEXT_COLOR = "#FFFFFF";

export const normalizeHexColor = (value) => {
  const trimmed = String(value || "").trim();
  if (!trimmed) return "";
  const match = trimmed.match(/^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/);
  if (!match) return "";
  return `#${match[1].toUpperCase()}`;
};

const expandHexColor = (hex) => {
  const normalized = normalizeHexColor(hex);
  if (!normalized) return "";
  const raw = normalized.slice(1);
  if (raw.length === 6) return raw;
  return raw
    .split("")
    .map((char) => `${char}${char}`)
    .join("");
};

const relativeLuminance = (hex) => {
  const expanded = expandHexColor(hex);
  if (!expanded) return 0;
  const channels = [0, 2, 4].map((start) => {
    const value = parseInt(expanded.slice(start, start + 2), 16) / 255;
    return value <= 0.03928
      ? value / 12.92
      : Math.pow((value + 0.055) / 1.055, 2.4);
  });
  return channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
};

export const getContrastRatio = (foreground, background) => {
  const foregroundLum = relativeLuminance(foreground);
  const backgroundLum = relativeLuminance(background);
  const lighter = Math.max(foregroundLum, backgroundLum);
  const darker = Math.min(foregroundLum, backgroundLum);
  return (lighter + 0.05) / (darker + 0.05);
};

export const getReadableTextColor = (backgroundColor) => {
  const background = normalizeHexColor(backgroundColor) || DEFAULT_PORTAL_PRIMARY_COLOR;
  const whiteContrast = getContrastRatio("#FFFFFF", background);
  const darkContrast = getContrastRatio("#0F172A", background);
  return whiteContrast >= darkContrast ? "#FFFFFF" : "#0F172A";
};

export const resolvePortalBrandColors = (settings = {}) => {
  const primary =
    normalizeHexColor(settings.primary_color) || DEFAULT_PORTAL_PRIMARY_COLOR;
  const nav = normalizeHexColor(settings.portal_nav_color) || primary;
  const primaryText =
    normalizeHexColor(settings.portal_button_text_color) ||
    DEFAULT_PORTAL_TEXT_COLOR;
  const navText =
    normalizeHexColor(settings.portal_nav_text_color) ||
    DEFAULT_PORTAL_TEXT_COLOR;
  return {
    primary,
    nav,
    primaryText,
    navText,
    navActiveText: primary,
  };
};

export const hasLowContrast = (foreground, background) => {
  const resolvedForeground = normalizeHexColor(foreground);
  const resolvedBackground = normalizeHexColor(background);
  if (!resolvedForeground || !resolvedBackground) return false;
  return getContrastRatio(resolvedForeground, resolvedBackground) < 4.5;
};
